import React from 'react';

const Footer = () => {
    return (
        <footer className="footer hor-footer" style={{bottom: 0}}>
  <div className="container">
    <div className="row align-items-center flex-row-reverse">
      <div className="col-md-12 col-sm-12 text-center">
        Copyright © {new Date().getFullYear()} <a href="https://intelligra.io/">Intelligra.</a>. All rights reserved.
      </div>
    </div>
  </div>
</footer>

    );
};

export default Footer;